import { render, staticRenderFns } from "./peer-specialists-testimonial.component.vue?vue&type=template&id=0e5c5976&"
import script from "./peer-specialists-testimonial.component.ts?vue&type=script&lang=ts&"
export * from "./peer-specialists-testimonial.component.ts?vue&type=script&lang=ts&"
import style0 from "./peer-specialists-testimonial.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports